import { render, staticRenderFns } from "./importOrders.vue?vue&type=template&id=24530d70&scoped=true"
import script from "./importOrders.vue?vue&type=script&lang=js"
export * from "./importOrders.vue?vue&type=script&lang=js"
import style0 from "./importOrders.vue?vue&type=style&index=0&id=24530d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24530d70",
  null
  
)

export default component.exports